import Axios from '@/utils/axios'

const URL = '/cids'

export default {
  buscaCids: (cidOuNome) => Axios.get(`${URL}`, { params: { cidOuNome } }),
}
